module.exports = __webpack_public_path__ + "static/media/reminiscent-of-home.0c741def.jpg";